import { NgModule } from '@angular/core';
import { FormatDatePipe } from './formatDate';

@NgModule({
  declarations: [FormatDatePipe],
  exports: [FormatDatePipe]
})
export class FormatDateModule { }
